import ProviderAPI from "../../services/Provider";

class General {
  confirmAuthentication() {
    return async (dispatch) => {
      try {
        localStorage.setItem(
          "didAuthenticate",
          JSON.stringify({ didAuthenticate: true })
        ); // this needs to be used with tokens generated on the server-side. just a mock for now
        dispatch({ type: "USER_SMS_AUTHENTICATED", data: null });
      } catch (e) {
        console.log(e);
      }
    };
  }

  fetchAutocomplete(countryId, text) {
    return async (dispatch) => {
      try {
        let data = await ProviderAPI.searchSubjects(countryId, text);
        dispatch({ type: "ADD_AUTOCOMPLETE", data });
        return data;
      } catch (e) {
        console.log(e);
      }
    };
  }

  setStageCompleted(stage) {
    return (dispatch) => {
      dispatch({ type: "SET_STAGE_COMPLETED", stage });
    };
  }

  setSelectedPackage(selectedPackage) {
    return (dispatch) => {
      dispatch({ type: "SET_SELECTED_PACKAGE", selectedPackage });
    };
  }

  setPackages(packages) {
    return (dispatch) => {
      dispatch({ type: "SET_PACKAGES", packages });
    };
  }

  setCountryDetails(countryDetails) {
    return async (dispatch) => {
      ProviderAPI.setAcceptLanguageHeader(countryDetails.AcceptLangCode);
      const currency = ProviderAPI.currencyEnums.find(
        (c) => c.id === countryDetails.CurrencyId
      );
      const countrySettings = await ProviderAPI.get(
        `api/provider/settings/${countryDetails.Id}`
      );

      dispatch({
        type: "SET_COUNTRY_DETAILS",
        payload: { countryDetails, currency, countrySettings },
      });
    };
  }

  setCountries(countries) {
    return (dispatch) => {
      dispatch({ type: "SET_COUNTRIES", countries });
    };
  }

  setGeoLocationData(geoLocationData) {
    return (dispatch) => {
      dispatch({ type: "SET_GEOLOCATION_DATA", geoLocationData });
    };
  }
}

export default new General();
